import React, { ReactElement } from "react";
import { create } from "zustand";

export type MODAL_TYPE = "SUCCESS" | "DANGER" | "WARNING" | "INFO";

export interface ConfirmModalProps {
	title?: string;
	text?: string | ReactElement;
	form?: any; // TODO: Also react node?
	body?: React.ReactNode;
	acceptButtonText?: string;
	rejectButtonText?: string;
	onReject?: any;
	onAccept?: any;
	type?: MODAL_TYPE;
}

interface ConfirmModalStore {
	showModal: boolean;
	modalData: ConfirmModalProps;

	toggleModal(): void;
	newModal(data: ConfirmModalProps): void;
	onAccept(): void;
	onReject(): void;
}

/**
 * Global confirm dialog (rendered by ConfirmationModal in LoggedInLayout).
 * Open one from anywhere with `useConfirmModalStore.getState().newModal({...})`
 * or via the hook inside components.
 */
export const useConfirmModalStore = create<ConfirmModalStore>()((set, get) => ({
	showModal: false,
	modalData: {},

	toggleModal() {
		set((state) => ({ showModal: !state.showModal }));
	},

	newModal(data) {
		set((state) => ({ showModal: !state.showModal, modalData: data }));
	},

	onAccept() {
		get().modalData.onAccept();
		get().toggleModal();
	},

	onReject() {
		const { onReject } = get().modalData;
		onReject && onReject();
		get().toggleModal();
	},
}));
